var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "facebook_svg__a",
    width: 20,
    height: 20,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#facebook_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6FB265",
    d: "M7.269 11.288V18.6h3.987v-7.312h2.974l.618-3.361h-3.592v-1.19c0-1.777.698-2.458 2.5-2.458.56 0 1.01.014 1.271.042V1.27C14.536 1.139 13.333 1 12.638 1c-3.675 0-5.37 1.736-5.37 5.48v1.447H5v3.361z"
  }))));
};
export default SvgFacebook;